import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class EmailAPI {

  static getList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/email/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure) => {
    const filter = [{field: 'model', type: 'model', "condition": "equals",
      value: `${modelType}~${modelId}`}];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/email/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static send = (model_no, model_id, data, html, success, failure) => {
    const email = { id: 0, model_no, model_id, source: 1,
      mail_to: data.to, cc: data.cc, subject: data.subject, html };
    fetch(Config.app.link + 'api/email/send', new Header('POST', email))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/email/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default EmailAPI;